export const NAVIGATION_PANEL_MIN_WIDTH_PX = 300;
